import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

const Footer = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <footer className="sticky-footer bg-white" style={{ height: 4 }}>
      <div className="container my-auto">
        <div className="copyright text-center my-auto">
          <span>{t('footer.diretios')}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
